module.exports = __webpack_public_path__ + "static/media/017ty@3x.2082cca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/017ty@3x.png
// module id = 1668
// module chunks = 0 1